@if (corporateTaxEntity$ | async) {
  <form [formGroup]="hirFg">
    <div formArrayName="specificatieHir">
      @for (item of specificatieHir.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row mb-1">
          <div class="col-auto">
            <snelstart-ui-text-form-control
              [label]="i === 0 ? 'Omschrijving bedrijfsmiddel' : ''"
              class="custom-input-250"
              formControlName="omschrijving"
              id="omschrijving"
            >
            </snelstart-ui-text-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-select-form-control
              [label]="i === 0 ? 'Jaar vervreemding' : ''"
              [options]="jaren"
              [required]="true"
              class="custom-input-150"
              formControlName="jaarVanVervreemding"
              id="jaar"
            >
            </snelstart-ui-select-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-number-form-control
              [label]="i === 0 ? 'Boekwinst' : ''"
              [showAllDecimals]="false"
              align="right"
              class="custom-input-150"
              formControlName="boekwinst"
              id="boekwinst"
              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-number-form-control
              [label]="i === 0 ? 'Afschrijvingspercentage' : ''"
              [showAllDecimals]="true"
              align="right"
              class="custom-input-150"
              formControlName="afschrijvingspercentage"
              id="afschrijvingspercentage"
              postfix="%"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-number-form-control
              [label]="i === 0 ? 'Boekwaarde' : ''"
              [showAllDecimals]="false"
              align="right"
              class="custom-input-150"
              formControlName="boekwaardeOpVervreemdingsmoment"
              id="boekwaardeOpVervreemdingsmoment"
              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-button
              (click)="verwijderRij(i)"
              [class]="i === 0 ? 'firstrowbutton' : ''"
              icon="trash"
              iconType="light"
              id="buttonDelete"
              size="medium"
              type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button
    (click)="addRij()"
    class="snelstart-ui-button pb-3"
    icon="plus"
    id="cancel"
    type="link"
  >Bedrijfsmiddel toevoegen
  </snelstart-ui-button>
}
